import { deserialize, serializable } from 'serializr';
import { Base } from './base.model';

export class Entity extends Base {
  @serializable
  public name: string;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(Entity, input));
  }
}
